import { Outlet } from "react-router-dom"
import { motion } from "framer-motion"

export function AuthLayout() {
  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-blue-500/10 via-background to-indigo-500/10 dark:from-blue-600/20 dark:via-background dark:to-purple-600/20 relative overflow-hidden">
      <div className="w-full max-w-md p-8 relative z-10">
        {/* Padlo Bear - positioned above the form */}
        <div className="absolute -top-18 left-1/2 transform -translate-x-1/2 z-0">
          <motion.div
            className="relative"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 3, duration: 1, ease: "easeOut" }}
          >
            <motion.img
              src="/branding/padlo_bear_sm.png"
              alt="Padlo Bear Mascot"
              className="w-40 h-40 object-contain drop-shadow-2xl opacity-90 dark:opacity-75 hover:scale-105 transition-transform duration-500 ease-out"
              animate={{
                rotate: [0, -2, 2, -2, 2, 0]
              }}
              transition={{
                delay: 10,
                duration: 0.1,
                repeat: Infinity,
                repeatDelay: 2,
                ease: "easeInOut"
              }}
              whileHover={{ scale: 1.05 }}
            />
            {/* Subtle glow effect */}
            <div className="absolute inset-0 w-40 h-40 bg-gradient-to-r from-primary/15 to-purple-500/15 rounded-full blur-2xl -z-10"></div>
          </motion.div>
        </div>

        <div className="rounded-xl border bg-card/95 backdrop-blur-sm p-8 shadow-xl dark:shadow-2xl dark:shadow-primary/5 hover:shadow-2xl hover:shadow-primary/10 transition-all duration-300">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
